// src/components/Breadcrumb.jsx
import React from "react";
import { Link } from "react-router-dom";
import theme from "../styles/theme/theme";

const Breadcrumb = ({ items }) => {
  return (
    <nav aria-label="breadcrumb" style={{ marginBottom: theme.spacing(4) }}>
      <ol
        style={{
          display: "flex",
          listStyle: "none",
          padding: 0,
          margin: 0,
          flexWrap: "wrap",
          gap: theme.spacing(1),
        }}
      >
        {items.map((item, idx) => (
          <li key={idx} style={{ display: "flex", alignItems: "center" }}>
            {idx !== 0 && <span style={{ margin: "0 0.5rem" }}>›</span>}
            {item.url ? (
              <Link
                to={item.url}
                style={{ color: theme.palette.primary.main, textDecoration: "none" }}
              >
                {item.label}
              </Link>
            ) : (
              <span style={{ color: theme.palette.text.primary }}>{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
